const types = require('../types');
const baggage = require('./baggage');

function parse(hexAsString) {
    try {
        if (hexAsString.length <= 2) {
            return null;
        }
        let header = hexAsString.substring(0, 2);
        let result = null;
        switch (header.ToUpper()) {
            //IATA RP1740c Baggage Handling
            case types.baggage.prefix:
                result = baggage.parse(hexAsString);
                break;
            default:
                result = null;
                break;
        }
        return result;
    } catch (ex) {
        const newError = new Error('Unable to Parse ' + hexAsString + ': ' + ex.message);
        newError.stack = ex.stack;

        throw newError;
    }
}

module.exports = {
    parse
};
